import axios from 'axios';
import { toast } from 'react-hot-toast';
import { BASE_URL } from '../utils/api';
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 🔐 Automatically attach Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ❌ Global response error handler
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const msg = error?.response?.data?.message || 'Something went wrong';

    if (error.response?.status === 401) {
      toast.error('Session expired. Please login again.');
      localStorage.removeItem('token');
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    } else if (error.response?.status === 403) {
      toast.error('Access denied.');
    } else {
      toast.error(msg);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
